import React, {useState, useEffect} from 'react';
import {Upload, Modal} from 'antd';
import iconAdd from '../../../../assets/images/icon_music_add.png';
import iconPlay from '../../../../assets/images/icon_music_play.png';
import iconPause from '../../../../assets/images/icon_music_pause.png';
import iconDel from '../../../../assets/images/icon_music_del.png';
import iconNone from '../../../../assets/images/icon_music_none.png';
import './index.less';

const MusicItem = props => {
    const {name, type, musicTab, id, url, audioRef, onSelect, opt, duration,
        onUpload, onDel, mood, musicConfig = {}, setMusicConfig, curAudioSrc, setCurAudioSrc} = props;
    const {delApi} = opt || {};

    const [playing, setPlaying] = useState(false);
    const [showDel, setShowDel] = useState(false);
    useEffect(() => {
        return () => {
            if (audioRef && audioRef.current) {
                audioRef.current.src = '';
            }
        };
    }, []);
    useEffect(() => {
        audioRef.current && audioRef.current.addEventListener('timeupdate', onAudioTimeUpdate);

        return () => {
            audioRef.current && audioRef.current.removeEventListener('timeupdate', onAudioTimeUpdate);
        };
    }, [url]);

    useEffect(() => {
        if (curAudioSrc !== url) {
            setPlaying(false);
        }
    }, [curAudioSrc]);

    const onAudioTimeUpdate = () => {
        const {currentTime, duration, src} = audioRef.current;

        if (src !== url) {
            return;
        }

        if (currentTime === duration) {
            setPlaying(false);
        }
    };

    const del = async e => {
        typeof onDel === 'function' && onDel(id);
    };

    const handlePlay = e => {
        e.stopPropagation();
        const {volume = 18} = musicConfig;
        if (playing) {
            audioRef.current.pause();
            audioRef.current.src = '';
            setPlaying(false);
        } else {
            setCurAudioSrc(url);
            audioRef.current.src = url;
            audioRef.current.volume = volume / 100;
            audioRef.current.play();
            setPlaying(true);
        }
    };

    const onClickDel = e => {
        e.stopPropagation();

        setShowDel(true);
    };

    const onClick = () => {
        const payload = {
            id,
            name,
            url,
            duration,
            volume: 18, // 0-100
            is_circle: 1, // 0 1
            range: 'cur_page'
        };
        onSelect({...payload});
        setMusicConfig({...payload});
    };

    const onClear = () => {
        const payload = {
            id: '',
            name: '',
            url: '',
            duration: '',
            is_circle: 0,
            range: 'cur_page'
        };
        onSelect({...payload});
        setMusicConfig({...musicConfig, ...payload});
    };


    if (type === 'add') {
        return (
            <div className="digital-resource-lib-item music-item">
                <Upload
                    customRequest={onUpload}
                    showUploadList={false}
                    accept={opt.fileFilter}
                >
                    <div className="music-item-imgwrapper add">
                        <img className="icon icon-add" src={iconAdd} />
                        <p className="add-text">点击或拖拽上传</p>
                    </div>
                </Upload>
            </div>
        );
    }

    if (type === 'clear') {
        return (
            <div className="digital-resource-lib-item music-item" onClick={onClear}>
                <div className="music-item-imgwrapper">
                    <img className="icon icon-add" src={iconNone} />
                    <p className="name-empty">无背景音乐</p>
                </div>
            </div>
        );
    }

    return (
        <div
            className="digital-resource-lib-item music-item"
            onMouseLeave={() => setShowDel(false)}
            onClick={onClick}
        >
            <div className="music-item-imgwrapper">
                <img className="icon icon-add" src={playing ? iconPause : iconPlay} onClick={handlePlay} />
                <p className="name-text">{name}</p>
                <span className={`${musicTab === 'music' ? 'duration-text' : 'duration-only-text'}`}>{duration}</span>
                {delApi && musicTab === 'music'
                    ? (showDel ? <div className="del-btn" onClick={del}>删除</div>
                        : <img className="icon icon-del" src={iconDel} onClick={onClickDel} />)
                    : null}
            </div>
        </div>
    );
};

export default MusicItem;
